import { BaseConnector } from './baseConnector';

class CityAreaConnector extends BaseConnector {
  getCityAreas() {
    var url = `${this.baseApiUrl}/cityArea`;
    return this.authFetch(url);
  }

  getCityArea(cityAreaId) {
    var url = `${this.baseApiUrl}/cityArea/${cityAreaId}`;
    return this.authFetch(url);
  }

  createCityArea(cityArea) {
    var url = `${this.baseApiUrl}/cityArea`;
    return this.authPost(url, cityArea);
  }

  updateCityArea(cityAreaId, cityArea) {
    var url = `${this.baseApiUrl}/cityArea/${cityAreaId}`;
    return this.authPatch(url, cityArea);
  }

  deleteCityArea(cityAreaId) {
    var url = `${this.baseApiUrl}/cityArea/${cityAreaId}`;
    return this.authDelete(url);
  }
}

export { CityAreaConnector };
